import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=49adeda6&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"
import style0 from "./VCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49adeda6')) {
      api.createRecord('49adeda6', component.options)
    } else {
      api.reload('49adeda6', component.options)
    }
    module.hot.accept("./VCard.vue?vue&type=template&id=49adeda6&", function () {
      api.rerender('49adeda6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VCard.vue"
export default component.exports